import type { TranslationTree } from '../../types';

export const settings: TranslationTree = {
  globalSettings: {
    personalSpace: 'Persönlicher Bereich',
    title: 'Einstellungen',
    description:
      'Passen Sie die ToolLife-Erfahrung an und greifen Sie auf Ihre bevorzugten Verknüpfungen zu.',
    personalizationTitle: 'Personalisierung',
    personalizationDescription:
      'Wählen Sie das Thema aus, das am besten zu Ihrem Arbeitsbereich passt.',
    quickNavigation: 'Schnellnavigation',
    noShortcut: 'Keine Verknüpfung',
    securityReminder: 'Sicherheitswarnung',
    logoutCta: 'Abmelden',
    shortcuts: {
      adminTitle: 'Administration',
      adminDescription: 'Verwalten Sie Benutzerdaten und -einstellungen.',
      toolsTitle: 'Werkzeuge',
      toolsDescription: 'Verwalten Sie Ihre Werkzeugdaten und -einstellungen.',
      profileTitle: 'Profil',
      profileDescription: 'Verwalten Sie Ihre Kontoinformationen und -einstellungen.',
    },
  },
};
